export default __webpack_public_path__ + "static/media/ta-logo.0a13635c.svg";